import {Box, Flex, Text} from '@chakra-ui/react'
import {getCharColorByScore} from './utilsExamResult'

const PopoverContent = ({word}: any) => {
  const getTextStatusByScore = (score: number) => {
    if (score < 0.5) return 'Thiếu âm'
    if (score < 0.75) return 'Sai âm'
    return 'Đúng'
  }

  const getColorByScore = (score: number) => {
    if (score <= 0.49) return '#B74645'
    if (score <= 0.75) return '#CCA400'
    return '#379652'
  }

  if (word.text === '~' || word.text === '•') {
    return (
      <Box
        p={'8px 20px'}
        bg={'white'}
        borderRadius={'12px'}
        shadow={' 0px 8px 16px 0px rgba(16, 24, 40, 0.15)'}
        zIndex={10}>
        {word.text === '~' && (
          <Text color={'#14AE5C'} fontSize={'24px'} fontWeight={600}>
            Good pause
          </Text>
        )}
        {word.text === '•' && (
          <Text color={'#EC652C'} fontSize={'24px'} fontWeight={600}>
            Bad pause
          </Text>
        )}
      </Box>
    )
  }

  return (
    <Box
      bg={'white'}
      borderRadius={'12px'}
      w={'400px'}
      shadow={' 0px 8px 16px 0px rgba(16, 24, 40, 0.15)'}
      zIndex={10}>
      <Flex
        p={'8px 20px'}
        justifyContent={'space-between'}
        alignItems={'center'}
        borderBottom={'1px solid #F0F0F0'}>
        <Text fontSize={'24px'} fontWeight={600}>
          {`${word.word} /`}
          {word.phones.map((item: any, index: any) => (
            <Text
              key={index}
              as={'span'}
              color={getCharColorByScore(item.score)}>
              {item.phone_ipa}
            </Text>
          ))}
          {'/'}
        </Text>
      </Flex>
      <Flex
        className="scroll-bar"
        maxH={'270px'}
        overflow={'auto'}
        p={'8px 20px'}
        flexDirection={'column'}
        fontSize={'16px'}>
        {Boolean(word.letters.find((item: any) => item.score < 0.75)) ? (
          word.phones.map((item: any, index: any) => {
            return (
              <Flex
                key={index}
                gap={'8px'}
                py={'12px'}
                borderTop={index !== 0 ? '1px solid #F0F0F0' : 'unset'}>
                <Text
                  w={'80px'}
                  fontSize={'16px'}
                  fontWeight={600}>{`/${item.phone_ipa}/`}</Text>
                <Text
                  fontSize={'16px'}
                  fontWeight={600}
                  color={getColorByScore(item.score)}>
                  {getTextStatusByScore(item.score)}
                </Text>
              </Flex>
            )
          })
        ) : (
          <Flex gap={'8px'} py={'12px'}>
            <Text
              flex={1}
              w={'80px'}
              fontSize={'16px'}
              color={'#379652'}
              fontWeight={600}>
              Bạn đã phát âm hoàn toàn đúng
            </Text>
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

export default PopoverContent
